import { createInjectionState } from '@vueuse/core';
import { ref, unref } from 'vue';

import { type CustomModalDialogApi, ModalCancelBehavior } from './bootstrap-modal';

export type DefaultConfirmationArgs = {
    message?: string;
    cancel?: boolean;
    rejectOnCancel?: boolean;
} | undefined;

export type ConfirmationFunction = (message?: string, args?: DefaultConfirmationArgs) => Promise<void>;

const [useProvideGlobalConfirm, useGlobalConfirmOptional] = createInjectionState((
    confirm: ConfirmationFunction,
) => ({
    confirm,
}));

export { useProvideGlobalConfirm };

export function useConfirm(provide?: boolean) {
    const confirmApi = ref<CustomModalDialogApi<[DefaultConfirmationArgs]> | undefined>();
    const confirm: ConfirmationFunction = function(message, args) {
        const _api = unref(confirmApi);
        if(!_api) {
            return Promise.reject(new Error('no api'));
        }
        if(!message) message = 'Confermi?';
        const onCancel = args?.rejectOnCancel ? ModalCancelBehavior.Reject : ModalCancelBehavior.NoReturn;
        return _api.showModalEx({ onCancel }, { message, ...args });
    };
    if(provide) {
        useProvideGlobalConfirm(confirm);
    }
    return [
        confirmApi,
        confirm,
    ] as const;
}

export function useGlobalConfirm() {
    const handler = useGlobalConfirmOptional();
    if(!handler) {
        throw new Error('Confirmation is not provided');
    }
    return handler.confirm;
}
